import { render, staticRenderFns } from "./NewPaymentsPayoneerEditAdmin.vue?vue&type=template&id=472feb2a&scoped=true"
import script from "./NewPaymentsPayoneerEditAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472feb2a",
  null
  
)

export default component.exports